module.exports = __webpack_public_path__ + "img/il.dbaa45c9.svg";